import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import sanityClient from '../Client'
import Hero from '../Components/Hero'


function Blogtags() {

    const { tag } = useParams()
    const [blogs, setBlogs] = useState()

    useEffect(() => {
        sanityClient.fetch(`*[_type == "post" &&  "${tag}" in categories[]->title]{
            title,
            description,
            slug,
            body,
            publishedAt,
            "categories": categories[]->{title, description},
            mainImage {
              asset->{
                _id,
                url
              },
              alt
            },
            author->{
              name,
              image {
                asset->{
                  url
                }
              }
            }
            }`).then((data) => setBlogs(data)).catch((error) => console.error(error))
    }, [tag])
    return (
        <>
            <main className='min-h-[calc(100vh-80px)]'>
                <Hero tag={tag} description={blogs && blogs[0]?.categories?.find(category => category.title === tag)?.description} />

                <section className='container mx-auto flex  w-full justify-center gap-5 mb-5 flex-wrap'>
                    {blogs && blogs.map((post, index) => (
                        <article className='h-[400px] w-[300px] border-[#ABABAB] border rounded-xl card' key={index}>

                            <Link to={"/blogs/" + post.slug.current} key={post.slug.current} className='flex flex-col gap-2 h-full '>

                                {/* YOU MAY CHANGE THE HEIGHT OF IMAGE */}
                                <img src={post.mainImage.asset.url} alt={post.mainImage.alt ? post.mainImage.alt : 'Image alt'} className=' rounded-t-xl object-cover h-[140px] w-full' />

                                <div className='flex flex-col gap-2 px-2 h-full'>

                                    <div className='flex gap-2'>
                                        {post?.categories && post.categories.map((tag, index) => (

                                            <Link to={`/blogs/tags/${tag.title}`} className='bg-[#D72638] text-white py-1 px-3 rounded-xl w-min transition hover:bg-transparent hover:text-[#D72638] hover:border-[#D72638] border' key={index}>{tag.title}</Link>
                                        ))}
                                    </div>

                                    <h1 className='text-3xl font-bold line-clamp-1' title={post.title}>{post.title}</h1>

                                    <p className='text-[#404040] text-lg line-clamp-3' title={post.description}>
                                        {post.description}
                                    </p>
                                </div>

                                <div className='flex items-center gap-4 p-2 rounded-b-xl'>
                                    <img src={post.author.image.asset.url} alt="author" className='h-12' />
                                    <span>{post.author.name}</span>
                                    <span>{new Date(post.publishedAt).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                                </div>
                            </Link>

                        </article>
                    ))}
                </section>

            </main>
        </>
    )
}

export default Blogtags